import * as _ from 'lodash'
import { globalStore, componentStore } from '@store/index'
import { ReceiveFailItem } from '@protocol/message'
import { getErrorText } from '@game/errtext'
import { message } from 'antd'

export function showReceiveFailItemsMessage(receiveFailItems: ReceiveFailItem[]) {
  const msg = ['최대 보유 개수를 초과하였습니다.']
  _.forEach(receiveFailItems, receiveFailItem => {
    const def = componentStore.getExtraOddsItemDetailByItemId(receiveFailItem.itemId)
    msg.push(`${def.name}은(는) ${def.maxCount}개까지 보유 가능합니다.`)
  })
  globalStore.pushDialogOk({ title: '알림', text: msg })
}

export function showReceiveItemErrorMessage(errorCode: number) {
  const errText = getErrorText(errorCode) || '아이템 수령을 실패하였습니다. 재시도 하시기 바랍니다.'
  message.info(errText)
}
